@let key = data().key;

<app-modal-header [title]="key.name" [eyebrow]="data().orgName + ' · API key'">
  <span modalHeaderBadges>
    @if (key.isRevoked) {
      <span class="txn-kind-badge txn-kind-badge--neutral">Revoked</span>
    } @else {
      <span class="badge--active org-dot-badge">Active</span>
    }
  </span>
  <p class="key-calls__meta">
    <span class="billing-table__mono">{{ key.prefix }}</span>
    <span class="key-calls__sep">·</span>
    Created {{ key.createdAt | date:'mediumDate' }}@if (key.createdBy) { by {{ key.createdBy.name }}}
    <span class="key-calls__sep">·</span>
    Last used {{ key.lastUsedAt ? (key.lastUsedAt | date:'mediumDate') : 'never' }}
  </p>
</app-modal-header>

<app-modal-body flush>
  @if (failed()) {
    <div class="empty-state">
      <p class="empty-state__title">Couldn't load calls for this key.</p>
      <button type="button" class="btn--secondary empty-state__action" (click)="load(page())">Try again</button>
    </div>
  } @else if (loading() && !rows().length) {
    <div class="admin-table-scroll">
      <table class="billing-table admin-stack admin-stack--org-calls">
        <thead>
          <tr>
            <th>Time</th><th>Source</th><th>Endpoint</th><th>Status</th>
            <th class="col-num">Latency</th><th class="col-num">Credits</th>
          </tr>
        </thead>
        <tbody>
          @for (i of [1, 2, 3, 4, 5, 6, 7, 8]; track i) {
            <tr>
              <td><app-skeleton width="140px" height="14px"></app-skeleton></td>
              <td><app-skeleton width="70px" height="14px"></app-skeleton></td>
              <td><app-skeleton width="120px" height="14px"></app-skeleton></td>
              <td><app-skeleton width="36px" height="14px"></app-skeleton></td>
              <td class="col-num"><app-skeleton width="50px" height="14px"></app-skeleton></td>
              <td class="col-num"><app-skeleton width="24px" height="14px"></app-skeleton></td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  } @else if (rows().length) {
    <div class="admin-table-scroll" [class.key-calls__table--busy]="loading()" [attr.aria-busy]="loading()">
      <table class="billing-table admin-stack admin-stack--org-calls">
        <thead>
          <tr>
            <th>Time</th><th>Source</th><th>Endpoint</th><th>Status</th>
            <th class="col-num">Latency</th><th class="col-num">Credits</th>
          </tr>
        </thead>
        <tbody>
          @for (c of rows(); track c.id) {
            <tr>
              <td>{{ c.createdAt | date:'MMM d, y, HH:mm:ss' }}</td>
              <td>{{ c.source }}</td>
              <td class="cell-endpoint"><span class="cell-endpoint__method">{{ c.method }}</span> /{{ c.endpoint }}</td>
              <td>
                @if (c.error) {
                  <span class="txn-status-badge txn-status-badge--error">{{ c.status }}</span>
                } @else {
                  <span class="cell-status--ok">{{ c.status }}</span>
                }
              </td>
              <td class="col-num">{{ c.latencyMs | latency }}</td>
              <td class="col-num">{{ c.credits }}</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  } @else {
    <div class="empty-state">
      <p class="empty-state__title">No calls with this key yet.</p>
    </div>
  }
</app-modal-body>

<app-modal-footer>
  <span modalFooterStart>{{ total() | number }} call{{ total() === 1 ? '' : 's' }}</span>
  @if (pages() > 1) {
    <button type="button" class="btn--secondary" [disabled]="page() <= 1 || loading()" (click)="load(page() - 1)">Previous</button>
    <span class="key-calls__page">Page {{ page() }} of {{ pages() }}</span>
    <button type="button" class="btn--secondary" [disabled]="page() >= pages() || loading()" (click)="load(page() + 1)">Next</button>
  }
</app-modal-footer>
